import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import Store from 'store/store';
import s from 'components/bolt/footer/footer.sss';
import { getGeoFromIPAsync, isUserInEU } from 'utils/clientUtils';

import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import { geoFromIP } from 'utils/bolt/geo';
import { getCopy } from 'utils/copy';

import Link from 'components/bolt/link/link';
import Button from 'components/bolt/button/button';
import HTML from 'components/core/html/html.js';
import * as webp from 'utils/bolt/webp';

let userRegion;
const getUserRegion = (() => {
	let promise;
	return (onCreate) => {
		if (!promise) {
			promise = geoFromIP();
			promise.then(onCreate);
		}
		return promise;
	};
})();

export default class Footer extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
		const geo = await getGeoFromIPAsync();
		this.setState({ userCountry: geo?.countryCode });
		const userInEU = await isUserInEU();
		this.setState({ userOutsideEU: !userInEU });
	}

	filterOutCookiePolicy(items = {}) {
		let filteredItems = {};
		Object.keys(items).forEach((key) => {
			if (key !== 'cookies') filteredItems[key] = items[key];
		});

		return filteredItems;
	}

	renderDoNotSellLogo() {
		const { appData } = Store.get();
		const imageRoot = appData.urls.roots.sharedImages;

		return (
			<img class={s.doNotSellLogo} src={imageRoot + '/Your_Privacy_Choices.png'} alt="Your privacy choices logo" />
		);
	}
	
	renderLinks(items, type) {
		const { userCountry, userOutsideEU } = this.state;

		const filteredItems = (userOutsideEU ? this.filterOutCookiePolicy(items) : items) || {};

		const usingOneTrust = this.props.store?.appData?.options?.oneTrustCookieConsent?.scripts;
		const oneTrustCookieToggleID = Object.keys(filteredItems).find(key => filteredItems[key]?.url?.toLowerCase()?.includes('onetrust.toggleinfodisplay'));

		if (filteredItems[oneTrustCookieToggleID]?.copyUS && userCountry === 'us') {
			const itemsDupe = { ...filteredItems };
			const oneTrustCookieToggleUS = { ...filteredItems[oneTrustCookieToggleID] };
			oneTrustCookieToggleUS.$copy = oneTrustCookieToggleUS.copyUS;
			itemsDupe[oneTrustCookieToggleID] = oneTrustCookieToggleUS;

			return this.renderLinkSource(itemsDupe, type);
		}

		if (type !== 'link' || !usingOneTrust || !oneTrustCookieToggleID || userCountry !== 'us') {
			return this.renderLinkSource(filteredItems, type);
		}
		return this.renderLinkSource(filteredItems, type);
	}

	renderLinkSource(items, type) { 
		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);
		items = sortObjectByOrder(items, (item, key) => ({ key, ...item })).filter(item => {
			const ageGateShowOnly = +item.ageGateShowOnly || 0;
			if (ageGateShowOnly) {
				// ageGateShowOnly = 1 : age over the limit only
				if (ageGateShowOnly === 1 && ageGateEnabled && !isOfAge) {
					return false;
				}
				// ageGateShowOnly = 2 : age under the limit only
				if (ageGateShowOnly === 2 && isOfAge) {
					return false;
				}
			}
			if ((item.excludeFromShowtimes && this.showtimesFooter) || (item.showtimesOnly && !this.showtimesFooter)) {
				return false;
			}
			if (item.userRegion) {
				// If we don't have the region yet, start getting it and then rerender once we have it
				getUserRegion(geo => {
					userRegion = geo?.countryCode;
					this.forceUpdate();
				});
				const valid = item.userRegion.split(',').map(r => r.trim().toLowerCase()).includes(userRegion);
				if (!valid) {
					return false;
				}
			}
			return true;
		});

		let links = [];

		const isAuRegion = __REGION__ === 'au' || __REGION__ === 'nz';

		if (type === 'link' && (this.tealiumCookiesEnabled || (this.ensightenTrackingEnabled && !isAuRegion))) {
			links.push(
				<li class={s[`${type}Wrapper`]} key="tealium">
					<Button
						class={joinClasses(s[`${type}Link`], this.fontStyles.footerLegalLinks)}
						trigger={this.ensightenTrackingEnabled ? this.ensightenAction : this.tealiumAction}
					>
						{accessNested(this.props, 'store.appData.copy.baseCopy.$COOKIE_SETTINGS') || 'Cookie Settings'}
					</Button>
				</li>
			);
		}

		return links.concat(items.map((item, key) => {
			let content;
			if (type === 'logo') {
				const fileImg = item.src;
				const fallbackFormat = this.getFallbackFormat();

				content = (
					<webp.Picture
						class={s.logo}
						src={fileImg}
						alt={getCopy(item.alt, {}, '', null, 'accessibilityCopy') || item.alt}
						fallbackFormat={fallbackFormat}
					/>
				);

			} else {
				content = getCopy(item.$copy, {}, '', null, 'baseCopy') || item.$copy;
			}

			if (type === 'copyright') {
				content = (
					<HTML
						content={content}
						markdown
					/>
				);
			}

			if (item.url && item.url.startsWith('@')) {
				return (
					<li class={s[`${type}Wrapper`]} key={key}>
						<Button
							class={joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks'])}
							trigger={() => Store.emit('OPEN_RESERVED_VARIABLE_LINK', item.url)}
						>
							{content}
						</Button>
					</li>
				);
			}

			if (item.url && accessNested(Store.get(), `appData.pages.${item.url}`, false)) {
				return (
					<li class={s[`${type}Wrapper`]} key={key}>
						<Button
							class={joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks'])}
							trigger={() => Store.emit('CLOSE_AND_NAVIGATE', item.url, '', { instant: false })}
						>
							{content}
						</Button>
					</li>
				);
			}

			const PrivacyChoicesLogo = item.PrivacyChoicesLogo;

			let Element = item.url ? Link : 'div';
			if (!item.url && item.openCookieConsentTool) {
				Element = 'button';
			}
			let attributes = {
				class: joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks'], PrivacyChoicesLogo && s.doNotSellLink, this.state.userCountry === 'us'),
				ariaLabel: item.ariaLabel,
				title: item.title,
				onClick: item.openCookieConsentTool ? this.openEvidon : () => this.onLinkClick(item)
			};
			if (item.url) {
				const disableNoOpNoRef = accessNested(this.props, 'data.defaultFooter.disableNoOpenerNoReferrer', false);
				attributes.href = item.url;
				attributes.target = item.target || '_blank';
				attributes.rel = !disableNoOpNoRef && 'noopener noreferrer';
			}

			return (
				<li class={s[`${type}Wrapper`]} key={key}>
					<Element {...attributes}>
						{content} {PrivacyChoicesLogo && this.renderDoNotSellLogo()}
					</Element>
				</li>
			);
		}));
	}
}